import React from 'react';
import { styled } from '@mui/material/styles';
import { useRouter } from 'next/router';
import Box from '@mui/material/Box';
import { useSession } from 'next-auth/react';

const Container = styled('div')(({ $imageLocation }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  '@media screen and (min-width: 993px)': {
    flexFlow: 'row',
    justifyContent: $imageLocation === 'left' ? 'right' : 'left',
    flexDirection: $imageLocation === 'left' ? 'row-reverse' : 'row',
    minHeight: '475px',
  },
  '@media screen and (max-width: 992px)': {
    flexFlow: 'column',
    minHeight: '550px',
  },
}));

const ImageContainer = styled('div')(({ $imageLocation }) => ({
  '@media screen and (min-width: 993px)': {
    [($imageLocation === 'left' ? 'left' : 'right')]: '5%',
    position: 'absolute',
    top: '35px',
    margin: 0,
    maxWidth: '45%',
    height: '100%',
  },
  '@media screen and (max-width: 992px)': {
    height: '90%',
  },
}));

const HeroImage = styled('img')`
  height: 250;
  width: 250;
  border-radius: 50%;
  object-fit: cover;
`;

const TitleContainer = styled('div')(({ $imageLocation }) => ({
  '@media screen and (min-width: 601px)': {
    [($imageLocation === 'left' ? 'left' : 'right')]: '43%',
    width: '55%',
    margin: 0,
    position: 'absolute',
    top: '35%',
  },
  '@media screen and (max-width: 992px)': {
    textAlign: 'center',
    width: '100%',
    padding: '15px 10px',
  },
}));

const Title = styled('div')(({ $imageLocation }) => ({
  fontWeight: 600,
  textTransform: 'uppercase',
  '@media screen and (min-width: 993px)': {
    fontSize: '3.375rem',
    lineHeight: '3.125rem',
    textAlign: $imageLocation === 'left' ? 'left' : 'right',
  },
  '@media screen and (max-width: 992px)': {
    fontSize: '2rem',
    lineHeight: '2.25rem',
    textAlign: 'center',
  },
}));

const ActionImageWithButton = ({ module }) => {
  const { fields } = module;

  const _router = useRouter();
  const { data: _session } = useSession();

  const _callAction = (event) => {
    event.preventDefault();
    _router.push(fields.actionButtonUrl.href);
  };

  return (
    <Box
      sx={{
        width: '100%',
        mt: '20px',
        mb: '20px',
        ml: 'auto',
        mr: 'auto',
        maxWidth: { sm: '540px', md: '768px', lg: '1180px', xl: '1180px' },
      }}
    >
      {/* {!session && ( */}
      <Container $imageLocation={fields.imageLocation}>
        <TitleContainer $imageLocation={fields.imageLocation}>
          <Title $imageLocation={fields.imageLocation}>{fields.title}</Title>
        </TitleContainer>
        <ImageContainer $imageLocation={fields.imageLocation}>
          {fields.heroImage && (
            <HeroImage src={fields.heroImage.url} alt={fields.heroImage.text} />
          )}
        </ImageContainer>
      </Container>
      {/* )} */}
    </Box>
  );
};

export default ActionImageWithButton;
